// src/app/models/user-admin-view.ts

import { User } from './user';
import { Role } from './role';
import { Injectable } from '@angular/core';
import { Adapter } from './adapter';

export class UserAdminView extends User {

  constructor(
    // Passe toutes les propriétés de la classe parente "User"
    public_id: string,
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    createdAt: Date,
    updatedAt: Date | null,
    languageCode: string,
    // Déclare uniquement les nouvelles propriétés de cette classe
    public is_admin: boolean,
    public is_active: boolean,
    public application_roles: Role[],
  ) {
    // Appelle le constructeur de la classe parente avec ses propriétés
    super(
      public_id,
      firstName,
      lastName,
      email,
      password,
      createdAt,
      updatedAt,
      languageCode
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserAdminViewAdapter implements Adapter<UserAdminView> {

  adapt(item: any): UserAdminView {
    const updatedAt = item.updated_at ? new Date(item.updated_at) : null;
    const createdAt = item.created_at ? new Date(item.created_at) : null;

    return new UserAdminView(
      item.public_id,
      item.firstname,
      item.lastname,
      item.email,
      '', // Password is not returned from the server for security reasons
      new Date(item.created_at),
      updatedAt,
      item.language_code,
      item.is_admin,
      item.active,
      item.application_roles
    );
  }
}